import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 39.03 39.03",
  "content": "<symbol viewBox=\"0 0 39.03 39.03\" id=\"icon-close\">\r\n    <path d=\"M39,7.62a3,3,0,0,0-.92-2.23L33.64.92a3.17,3.17,0,0,0-4.47,0l-9.66,9.66L9.86.92A3,3,0,0,0,7.62,0,3,3,0,0,0,5.39.92L.92,5.39A3,3,0,0,0,0,7.62,3,3,0,0,0,.92,9.86l9.66,9.66L.92,29.17a3.17,3.17,0,0,0,0,4.47l4.47,4.47A3,3,0,0,0,7.62,39a3,3,0,0,0,2.23-.92l9.66-9.66,9.66,9.66a3.17,3.17,0,0,0,4.47,0l4.47-4.47a3.17,3.17,0,0,0,0-4.47l-9.66-9.66,9.66-9.66A3,3,0,0,0,39,7.62Z\" transform=\"translate(0 0)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/close.svg
// module id = ./app/general/svg/close.svg
// module chunks = app